import React, { useContext } from "react";
import { Switch, Redirect } from "react-router-dom";
import PrivateRoute from "../Auth/PrivateRoute";
import Packages from "../Packages";
import ExceptionPage from "../Exceptions";
import Roles from "../Roles";
import RoleDetailView from "../Roles/RoleDetailView";
import Documents from "../Documents";
import Settings from "../Settings";
import Account from "../Settings/components/Account";
import ProjectManagement from "../Settings/components/ProjectManagement";
import ProjectDetails from "../Settings/components/ProjectDetails/index";
import ProjectOnboarding from "../Settings/components/ProjectOnboarding";
import AuditLogs from "../Settings/components/AuditLogs";
import "./styles.css";
import ProcuringEntity from "../ProcuringEntities/components/ProcuringEntity";
import Users from "../Users";
import UserDetailView from "../Users/UserDetailView";
import { AppContext } from "../../context/AppContext";
import { ROUTES } from "../../Util/routes";
import SelectReport from "../SelectReport";

const Routes = () => {
  const {  appRoutes: routes, permissions, selectedReportID, selectedProject } = useContext(AppContext);

  return (
    <Switch>

      {/* Redirect root path '/' to Overview or fallback to Packages based on permissions */}
      <PrivateRoute
        exact
        path={ROUTES.ROOT}
        render={(props) => {
          // Report-centric entry: if a report is selected and a project is known, go to project overview
          if (selectedReportID && selectedProject) {
            return <Redirect to={`/project/${selectedProject}/overview`} />;
          }
          // Otherwise, route to Select Report until user picks a report
          if (permissions.includes("can read project")) {
            return <SelectReport />;
          }
          if (permissions.includes("can read procuring-entity")) {
            return <ProcuringEntity {...props} />;
          }
          if (permissions.includes("can read package")) {
            return <Packages {...props} />;
          }
          return <Redirect to="/unauthorized" />;
        }}
     />
      <PrivateRoute
        exact
        path={ROUTES.USERS}
        render={(props) => {
          const hasUserAccess = permissions.includes("can read user") || 
                               permissions.includes("can create pit user") || 
                               permissions.includes("can create pct user");
          return hasUserAccess ? <Users {...props} /> : <Redirect to={{ pathname: "/unauthorized", state: { from: props.location } }} />;
        }}
      />
      <PrivateRoute
        exact
        path={`${ROUTES.USERS}/:userId`}
        render={(props) => {
          const hasUserAccess = permissions.includes("can read user") || 
                               permissions.includes("can create pit user") || 
                               permissions.includes("can create pct user");
          return hasUserAccess ? <UserDetailView {...props} /> : <Redirect to={{ pathname: "/unauthorized", state: { from: props.location } }} />;
        }}
      />

      {/* Top-level routes */}
      <PrivateRoute
        exact
      path={ROUTES.EXCEPTIONS}
            requiredPermissions={["can read exception"]}
            component={ExceptionPage}
      />
      <PrivateRoute
        exact
  path={ROUTES.ROLES}
        requiredPermissions={["can read role"]}
        component={Roles}
      />
      <PrivateRoute
        exact
        path={`${ROUTES.ROLES}/:roleId`}
        requiredPermissions={["can read role"]}
        component={RoleDetailView}
      />
      <PrivateRoute
        exact
  path={ROUTES.DOCUMENTS}
        requiredPermissions={["can read document"]}
        component={Documents}
      />
      {/* Project Management moved to top-level */}
      <PrivateRoute
        exact
        path={ROUTES.PROJECT_MANAGEMENT}
        component={ProjectManagement}
      />
      <PrivateRoute
        exact
        path={ROUTES.PROJECT_ONBOARDING}
        component={ProjectOnboarding}
      />
      <PrivateRoute
        exact
        path={`${ROUTES.PROJECT_MANAGEMENT}/:projectId`}
        component={ProjectDetails}
      />
      <PrivateRoute
        exact
  path={ROUTES.SETTINGS}
        component={Settings}
      />
  {/* Settings sub-routes */}
      {/* Keep direct routes working but also expose under Settings */}
  <PrivateRoute exact path={`${ROUTES.SETTINGS}/account`} component={Account} />
  {/* Backwards compatibility: redirect old paths to new top-level */}
  <PrivateRoute
    exact
    path={`${ROUTES.SETTINGS}/project-management`}
    render={() => <Redirect to={ROUTES.PROJECT_MANAGEMENT} />}
  />
  <PrivateRoute
    exact
    path={`${ROUTES.SETTINGS}/project-management/:projectId`}
    render={({ match }) => (
      <Redirect to={`${ROUTES.PROJECT_MANAGEMENT}/${match.params.projectId}`} />
    )}
  />
  <PrivateRoute exact path={`${ROUTES.SETTINGS}/audit-logs`} requiredPermissions={["can read audit log"]} component={AuditLogs} />
      <PrivateRoute exact path={`${ROUTES.SETTINGS}/users`} render={(props) => {
        const hasUserAccess = permissions.includes("can read user") || 
                             permissions.includes("can create pit user") || 
                             permissions.includes("can create pct user");
        return hasUserAccess ? <Users {...props} /> : <Redirect to={{ pathname: "/unauthorized", state: { from: props.location } }} />;
      }} />
      <PrivateRoute exact path={`${ROUTES.SETTINGS}/users/:userId`} render={(props) => {
        const hasUserAccess = permissions.includes("can read user") || 
                             permissions.includes("can create pit user") || 
                             permissions.includes("can create pct user");
        return hasUserAccess ? <UserDetailView {...props} /> : <Redirect to={{ pathname: "/unauthorized", state: { from: props.location } }} />;
      }} />
      <PrivateRoute exact path={`${ROUTES.SETTINGS}/roles`} requiredPermissions={["can read role"]} component={Roles} />
      <PrivateRoute exact path={`${ROUTES.SETTINGS}/roles/:roleId`} requiredPermissions={["can read role"]} component={RoleDetailView} />

      {routes.map((route, i) => (
        <PrivateRoute
          key={`route-${i}`}
          path={route.path}
          exact={route.exact}
          component={route.component}
          requiredPermissions = {route.requiredPermissions}
        />
      ))}

    </Switch>
  );
};

export default Routes;
